import { apiClient } from '@/libs/axios';
import {
  toGetSessionDTO,
  type GetSessionDTO,
} from '../schemas/get-session.schema';

export const getSession = async (id: string): Promise<GetSessionDTO> => {
  const response = await apiClient.get(`session/${id}`);

  return toGetSessionDTO(response);
};
